import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Container, Title, Timeline, TimelineLastItem } from './styles';

import TimelineItem from '~/components/Section04TimelineItem';

import ModalImage from '~/components/ModalImage';

// import screen01 from '~/assets/tela-print-model.png';
import screen01 from '~/assets/tela-passo-01.jpg';
import screen02 from '~/assets/tela-passo-02.jpg';
import screen03 from '~/assets/tela-passo-03.jpg';
import screen04 from '~/assets/tela-passo-04.jpg';
import screen05 from '~/assets/tela-passo-05.jpg';
import screen06 from '~/assets/tela-passo-06.jpg';
import screen07 from '~/assets/tela-passo-07.jpg';
import screen08 from '~/assets/tela-passo-08.jpg';
import screen09 from '~/assets/tela-passo-09.jpg';
//import screen10 from '~/assets/tela-passo-10.png';

import ArrowDown from '~/components/ArrowDown';

export default function Section04({ id }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [imageShow, setImageShow] = useState();

  function showModal(image) {
    setModalVisible(true);
    setImageShow(image);
  }
  function closeModal() {
    console.log('teste');
    setModalVisible(false);
  }

  const timeline = [    
    {
      order: 1,
      title: 'Passo 1',
      text:
        'Acesse o site da Receita Federal e baixe o programa do Imposto de Renda.',
      image: screen01,
    },
    {
      order: 2,
      title: 'Passo 2',
      text: 'Preencha sua Declaração pelo <b>Modelo Completo</b> e certifique-se de que está tudo pronto para o envio.',
      image: screen02,
    },
    {
      order: 3,
      title: 'Passo 3',
      text:
        'Antes de enviar, acesse a aba <b>“Doações Diretamente na Declaração”</b>.',
      image: screen03,
    },
    {
      order: 4,
      title: 'Passo 4',
      text:
        'Escolha <b>“Criança e Adolescente”</b> ou <b>“Pessoa idosa”</b>. <br><br>⚠️ <b>Dica:</b> Você pode doar para os dois fundos! Faça uma doação por vez.', 
      image: screen04,
    },
    {
      order: 5,
      title: 'Passo 5',
      text: 'Clique em <b>“NOVO”</b>.',
      image: screen05,
    },
    {
      order: 6,
      title: 'Passo 6',
      text: 'Escolha entre <b>"MUNICIPAL"</b> ou <b>"ESTADUAL"</b>.<br><br> ⚠️ <b>Importante:</b> Este ano, o projeto para a Pessoa Idosa está disponível apenas no Fundo ESTADUAL.',
      image: screen06,
    },
    {
      order: 7,
      title: 'Passo 7',
      text: 'Preencha com: <br>• UF: São Paulo <br>• Cidade: São Paulo',
      image: screen07,
    },

    {
      order: 8,
      title: 'Passo 8',
      text:
        'Copie o valor disponível para doação no campo <b>“VALOR”</b>. ',
      image: screen08,
    },
    {
      order: 9,
      title: 'Passo 9',
      text:
        'Clique em <b>“OK”</b> e gere a DARF específica.',
      image: screen09,
    },
    {
      order: 10,
      title: 'Passo 10',
      text:
        'Se quiser doar para o outro fundo, repita o processo.',
      
    },
    {
      order: 11,
      title: 'Passo 11',
      text:
        'Pague as DARFs até o vencimento e <b>guarde os comprovantes</b>.',      
    },
    // {
    //   order: 10,
    //   title: 'Passo 10',
    //   text:
    //     'Encaminhe um e-mail para <a href="mailto:parcerias@fundasp.org.br">parcerias@fundasp.org.br</a> contendo:\n\nCópia do comprovante de pagamento da DARF\n\nIndicação do nome do projeto que apoiou (ver acima)\n\nSeus dados pessoais: nome completo, CPF, endereço e telefone.\n\n<span>Com essas informações em mãos, enviaremos a você uma Carta de Destinação que deve ser assinada, escaneada e devolvida no mesmo e-mail acima.\n\n</span> <span>ATENÇÃO: se o passo 10 não for realizado o valor destinado fica para o FUNDO e não vai para o projeto da PUC-SP. </span>',
    //   image: null,
    // },
  ];
  return (
    <Container id={id}>
      <Title>
        <span>Passo a Passo</span> para sua Doação
      </Title>
      <Timeline>
        {timeline.map((timeitems) => (
          <TimelineItem
            key={timeitems.order}
            order={timeitems.order}
            title={timeitems.title}
            text={timeitems.text}
            image={timeitems.image}
            openModal={showModal}
          />
        ))}
        {modalVisible ? (
          <ModalImage image={imageShow} closeModal={closeModal} />
        ) : (
          ''
        )}
        <TimelineLastItem>
          <header>
            <h2>Passo {timeline.length + 1} - Confirmação da Doação</h2>
            <p>
            Após o pagamento, envie um e-mail para{' '}
              <a href="mailto:parcerias@fundasp.org.br">parcerias@fundasp.org.br</a>{' '}
              com:
              <ul>
                <li>Cópia das <b>DARFs</b></li>
                <li>Cópia dos <b>comprovantes de pagamento</b></li>
                <li>
                  Seus <b>dados pessoais</b>: Nome completo, CPF, endereço e telefone
                </li>
              </ul>
            </p>

            <p>Com essas informações, enviaremos a Carta de Destinação, que deve ser assinada, escaneada e devolvida para o mesmo e-mail.</p>
              
              <p>
				<span>
				Importante: Se este passo não for realizado, o valor destinado ficará no fundo geral e não será direcionado aos projetos sociais da PUC-SP.
					</span>
				</p>
				<p><span>Sua doação faz a diferença!</span></p>
				<p>Ao seguir esses passos, você destina <b>3% + 3% do seu Imposto de Renda</b> para os projetos sociais da PUC-SP, <b>ajudando a transformar vidas</b>!</p>
          </header>
        </TimelineLastItem>
      </Timeline>

      <ArrowDown toElement="depoimentos" className="ArrowDown" />
    </Container>
  );
}

Section04.propTypes = {
  id: PropTypes.string,
};
